class StickyProductInfo {
  static DESKTOP_BREAKPOINT = 990;
  static STICKY_GAP = 20;

  constructor(productGrid) {
    this.productGrid = productGrid;
    this.productInfo = productGrid.querySelector('[data-sticky-product-info="true"]');
    this.stickyTrack = productGrid.querySelector('[data-sticky-product-track]');
    this.mediaWrapper = productGrid.querySelector('.product__media-wrapper');
    this.stickyHeader = document.querySelector('sticky-header');

    if (!this.productInfo || !this.stickyTrack || !this.mediaWrapper) return;

    this.onHeaderOffsetChange = (event) => {
      this.updateTopOffset(event.detail?.bottom);
    };
    this.onResize = this.debounce(this.handleResize.bind(this), 150);
    this.onMediaResize = this.debounce(() => {
      this.syncStickyTrack();
    }, 100);

    this.init();
  }

  init() {
    if (window.innerWidth < StickyProductInfo.DESKTOP_BREAKPOINT) return;

    this.updateTopOffset();
    this.syncStickyTrack();
    this.bindEvents();
    this.observeHeightChanges();
  }

  updateTopOffset(headerBottom) {
    let offset = headerBottom;

    if (offset == null || Number.isNaN(offset)) {
      const cssBottom = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position').trim();
      offset = cssBottom ? parseFloat(cssBottom) : 0;
    }

    if (!offset) {
      offset = this.stickyHeader?.header?.getBoundingClientRect().bottom || 80;
    }

    document.documentElement.style.setProperty('--pdp-sticky-top', `${offset + StickyProductInfo.STICKY_GAP}px`);
  }

  syncStickyTrack() {
    if (window.innerWidth < StickyProductInfo.DESKTOP_BREAKPOINT) {
      this.disable();
      return;
    }

    this.stickyTrack.style.height = `${this.mediaWrapper.offsetHeight}px`;
  }

  observeHeightChanges() {
    this.resizeObserver = new ResizeObserver(() => {
      this.stickyHeader?.scheduleHeaderOffsetUpdate?.();
      this.onMediaResize();
    });
    this.resizeObserver.observe(this.mediaWrapper);

    if (this.stickyHeader) {
      this.resizeObserver.observe(this.stickyHeader);
    }

    if (this.stickyHeader?.topBanner) {
      this.resizeObserver.observe(this.stickyHeader.topBanner);
    }

    this.getStickySlimBannerSections().forEach((section) => {
      this.resizeObserver.observe(section);
    });
  }

  getStickySlimBannerSections() {
    return [...document.querySelectorAll('.slim-banner-section--sticky')];
  }

  bindEvents() {
    document.addEventListener('header-offset-change', this.onHeaderOffsetChange);
    window.addEventListener('resize', this.onResize);

    if (this.stickyHeader) {
      this.stickyHeader.addEventListener('transitionend', this.onHeaderOffsetChange);
    }

    this.stickyHeader?.header?.addEventListener('transitionend', this.onHeaderOffsetChange);
  }

  handleResize() {
    this.stickyHeader?.scheduleHeaderOffsetUpdate?.();
    this.updateTopOffset();
    this.syncStickyTrack();
  }

  disable() {
    this.stickyTrack.style.height = '';
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }
}

function initStickyProductInfo(root = document) {
  root.querySelectorAll('.product.grid').forEach((productGrid) => {
    if (productGrid.querySelector('[data-sticky-product-info="true"]')) {
      new StickyProductInfo(productGrid);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initStickyProductInfo();
  document.querySelector('sticky-header')?.scheduleHeaderOffsetUpdate?.();
});

document.addEventListener('shopify:section:load', (event) => {
  const stickyHeader = document.querySelector('sticky-header');

  if (
    event.target.querySelector?.('.slim-banner--sticky') ||
    event.target.classList?.contains('slim-banner-section--sticky')
  ) {
    stickyHeader?.collectStickySlimBanners?.();
    stickyHeader?.updateSlimBannerPositions?.();
  }

  initStickyProductInfo(event.target);
  stickyHeader?.scheduleHeaderOffsetUpdate?.();
});
